export const isEmpty = (value) => value.length === 0;